module.exports = "  <div :class=\"className\">\n    <wc-icon v-if=\"showIcon\" class=\"icon\" :name=\"iconName\"></wc-icon>\n    <span class=\"message\">{{message}}</span>\n    <span class=\"description\">{{description}}<slot></slot></span>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/src/wc-ui/components/alert/alert.html
// module id = 288
// module chunks = 0